import { render, staticRenderFns } from "./SaveCollectionModal.vue?vue&type=template&id=aa6c190a&scoped=true"
import script from "./SaveCollectionModal.vue?vue&type=script&lang=js"
export * from "./SaveCollectionModal.vue?vue&type=script&lang=js"
import style0 from "./SaveCollectionModal.vue?vue&type=style&index=0&id=aa6c190a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6c190a",
  null
  
)

export default component.exports